import { useEffect } from "react";
import {useLocation} from "react-router-dom";
import * as React from "react";

interface IScrollToTopProps {
    children?: React.ReactNode;
}

const ScrollToTop: React.FC<IScrollToTopProps> = (props) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (props.children);
};

export default ScrollToTop;